import MxTypography from "../MxTypography";

interface MxAlertMessageProps {
  children?: React.ReactNode;
}

function MxAlertMessage(props: MxAlertMessageProps) {
  return (
    <MxTypography
      variant="overline"
      color="grey.600"
      fontWeight={400}
      textAlign={"center"}
    >
      {props.children}
    </MxTypography>
  );
}

export default MxAlertMessage;
